import {useQuery} from '@tanstack/react-query';

import {getCountryCodes} from '../api';
import {QUERY__COUNTRY_CODES} from '../queryKeys';

export const useGetCountryCodes = () => {
  return useQuery({
    queryKey: [QUERY__COUNTRY_CODES],
    queryFn: getCountryCodes,
  });
};
